import { render, staticRenderFns } from "./PrincipalFooter.vue?vue&type=template&id=1031f656&scoped=true&"
var script = {}
import style0 from "./PrincipalFooter.vue?vue&type=style&index=0&id=1031f656&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1031f656",
  null
  
)

export default component.exports